export default __webpack_public_path__ + "static/media/thumb.a6aac8f2.png";